/**
 * Tooltip copy for the Mute and Create Exclusion triggers (KIR-2606
 * review item #4). Centralised so a future copy edit is a one-file
 * change with the test fleet still pinning the rendered string.
 *
 * Wording confirmed by Kobi.
 */

export const MUTE_BUTTON_TOOLTIP =
  'Silence this alert for your workspace, detection and enforcement continue.';

export const CREATE_EXCLUSION_BUTTON_TOOLTIP =
  'Suppress future matching alerts, detection and enforcement will be disabled.';

export const SUPPORT_READONLY_TOOLTIP =
  'Support users have read-only access and cannot perform this action.';

/**
 * Shown when the alert's entity can't be added automatically because its
 * identity is redacted beyond what we can turn into a safe rule (e.g. a remote
 * MCP server whose address is a secret with no visible host prefix). The user
 * can still add it by hand on the Policies screen (KIR-3558).
 */
export const ADD_TO_LIST_MASKED_TOOLTIP =
  "This entity's address is hidden to protect a secret, so it can't be added automatically. Add it manually on the Policies screen.";
